import { each, enforce, test } from 'vest';

export interface DefinitionFormItem {
  languageCode: string;
  content: string;
}

/** The vest rules of a `definitions` list; call it inside a `create` suite. */
export const testDefinitions = (definitions: DefinitionFormItem[]) => {
  each(definitions, (def, index) => {
    test(`definitions.${index}.languageCode`, 'Language is required', () => {
      enforce(def.languageCode).isNotEmpty();
    });
    test(`definitions.${index}.content`, 'Content is required', () => {
      enforce(def.content).isNotEmpty();
    });
    // Compared by row position, so a blank row above does not shift the index.
    test(`definitions.${index}.languageCode`, 'This language is already used by another row', () => {
      enforce(
        !def.languageCode || definitions.findIndex(d => d.languageCode === def.languageCode) === index,
      ).isTruthy();
    });
  });
};
